export default {"gitHash":"6aecf80752ad15d93fc998fb63196389e9a27ddd","gitHashShort":"6aecf80","time":1650904289597,"platform":"linux","arch":"x64"};